import React from 'react';
import {Button} from 'tabler-react';
import {DataLoadingSpinner} from '../../utils/imageSource';

function LoadingButton(props)
{
    const Spinner = () => (
      <img src={DataLoadingSpinner} className="zoom2 pr-2" height="20" alt="spinner-white"/>
    )
    const {loadingState, preloadingText, loadingText} = props;
    return (
      <Button  type="submit" className={props.class} color="primary" disabled={loadingState}>
        {loadingState ? <> <Spinner /> <span>{loadingText}</span> </> : <span>{preloadingText}</span>}
      </Button>
    );
}

export default LoadingButton;